import { RiCloseFill } from "react-icons/ri"
import { 
    AbsoluteContainer, AppLabel, AppText, Circle, CustomContainer, 
    Divider, 
    FlexRow, GridContainer, SidePopup, SidePopupContainer 
} from "src/style"
import { ReactComponent as IncomeTransaction } from 'src/assets/img/income-transaction.svg'
import helpers from "src/utils/helpers"
import { moneyFormat } from "src/utils/utility"

export const TransactionDetails: React.FC<any> = ({data, close}) => {
    return (
        <>
            <SidePopupContainer onClick={close} />
            <SidePopup padding="3" data-aos="slide-left" width="58.5">
                <FlexRow justifyContent="space-between" rightPadding="4" topMargin="2.5" bottomMargin="2">
                    <AppLabel textSize="2" color="#16192C" fontWeight="600">Transaction Details</AppLabel>
                    <AbsoluteContainer top="0" right="0" onClick={close}>
                        <RiCloseFill className='close-icon' />
                    </AbsoluteContainer>
                </FlexRow>
                <CustomContainer topMargin="6">
                    <GridContainer>
                        <Circle size="6.4" bgColor="#F7FAFC">
                            <IncomeTransaction/>
                        </Circle>
                    </GridContainer>
                    <CustomContainer 
                        minHeight="48.2" radius="1.2" bgColor="#F7FAFC" 
                        padding="2" topMargin="2.5"
                    >
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Transaction type</AppLabel>
                            <AppText fontWeight="600" color="#16192C">{data?.transactionType}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Loan type</AppLabel>
                            <AppText fontWeight="600" color="#16192C">{data?.loanType || 'Nill'}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Amount</AppLabel>
                            <AppText fontWeight="600" color="#16192C">₦{moneyFormat(data?.amount)}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Operation</AppLabel>
                            <AppText fontWeight="600" color={data.operation === 'Debit' ? '#F16063' : '#4AAE8C'}>{data?.operation}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Date</AppLabel>
                            <AppText fontWeight="600" color="#16192C">{helpers.splitDateTime(data.dateAdded)?.date}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Time</AppLabel>
                            <AppText fontWeight="600" color="#16192C">{helpers.splitDateTime(data.dateAdded)?.time} {helpers.splitDateTime(data.dateAdded)?.timeEnv}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Status</AppLabel>
                            <AppText fontWeight="600" color={data?.status === 'success' ? "#4AAE8C" : "#F16063"}>{data?.status}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Email Address</AppLabel>
                            <AppText fontWeight="600" color="#16192C">{data?.emailAddress}</AppText>
                        </FlexRow>
                        <FlexRow justifyContent="space-between" bottomMargin="2.5">
                            <AppLabel>Customer ID</AppLabel>
                            <AppText fontWeight="600" color="#16192C">{data?.customerId}</AppText>
                        </FlexRow>
                        <Divider margin="5" bgColor="rgba(160, 174, 192, 0.4)" />
                    </CustomContainer>
                </CustomContainer>
            </SidePopup>
        </>
    )
}